import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenMapZonesComponent} from './components/loren-map-zones/loren-map-zones.component';
import {LorenGeofencingAllCirclesResolver} from './resolvers/loren-geofencing-all-circles-resolver/loren-geofencing-all-circles.resolver';
import {LorenGeofencingAllPolygonsResolver} from './resolvers/loren-geofencing-all-polygons-resolver/loren-geofencing-all-polygons.resolver';

const routes: Routes = [
    {
        path: '',
        resolve: {
            circles: LorenGeofencingAllCirclesResolver,
            polygons: LorenGeofencingAllPolygonsResolver
        },
        component: LorenMapZonesComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenGeofencingRoutingModule {
}
